import { withBanSearchTermSection } from './withBanSearchTermSection'
import { ManageSearchTermTemplate } from '../ManageSearchTermTemplate'

const ConnectedBanSearchTermSection = withBanSearchTermSection(
  ManageSearchTermTemplate
)

export { ConnectedBanSearchTermSection as BanSearchTermSection }
